// LoginContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import useVendorDetails from "../hooks/VendorDetails";


const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const { data, isLoading, error, refresh } = useVendorDetails(); // Fetch data using your custom hook
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (data) {
      setUserData(data);
    }
  }, [data]);

  const value = {
    userData,
    isLoading,
    error,
    refresh,
  };

  return (
    <LoginContext.Provider value={value}>
      {children}
    </LoginContext.Provider>
  );
};

// Custom hook for easy usage
export const useLoginContext = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error("useLoginContext must be used within a LoginProvider");
  }
  return context;
};
